import { useTheme } from '@emotion/react';
import React from 'react';

import { Alert, Box } from '~/components/blocks';

export const FilePane = () => {
  const theme = useTheme();
  return (
    <Box padding={theme.space.l}>
      <Alert status="info">Web問診に回答した患者のため、ファイルはありません</Alert>
    </Box>
  );
};
